/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoodAngry = createReactComponent("mood-angry", "IconMoodAngry", [
  ["path", { d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", key: "svg-0" }],
  ["path", { d: "M8 9l2 1", key: "svg-1" }],
  ["path", { d: "M16 9l-2 1", key: "svg-2" }],
  ["path", { d: "M14.5 16.05a3.5 3.5 0 0 0 -5 0", key: "svg-3" }]
]);

export { IconMoodAngry as default };
//# sourceMappingURL=IconMoodAngry.js.map
